<template>
  <div class="feed">
    <div class="list">
      <List :loading="loading" :finished="finished" @load="onLoad">
        <template v-if="props.detailType != 3">
          <div v-for="(item, index) in list" :key="index" clstag="8YQ5|108807" :data-qidian-ext="
            JSON.stringify({
              page_source: 2710513,
              page_name: props.headerData.sceneCollName,
              type: item.templateType,
              contentid: item.templateData.contentType == 104 ? item.templateData.contentId : item.templateData.contentData.contentId,
              tagid: props.subjectVoList[props.active].topicAliasName,
              sourceName: props.subjectVoList[props.active].topicKey,
              sourceId: props.subjectVoList[props.active].id
            })
          ">
            <a :href="handleURL(item)" :title="item.templateData.contentData.contentTitle.text">
              <div class="content-box" :class="list.length == 1 ? 'content-box-radius' : ''"
                v-if="item.templateData.contentData.contentType == 1">
                <div class="content-border">
                  <div class="content">
                    <div class="text text-article">
                      <img class="top" v-if="item.templateData.contentData.topUrl"
                        :src="item.templateData.contentData.topUrl" />
                      <h2 :class="item.templateData.contentData.topUrl ? 'top-padding' : ''">{{
                        item.templateData.contentData.contentTitle.text }}</h2>
                    </div>
                    <div class="publish">
                      <span class="name">{{ item.templateData.titleData.title1.text }}</span>
                      <span class="time">{{ item.templateData.titleData.title2.text }}</span>
                    </div>
                  </div>
                  <img class="image"
                    v-if="item.templateData.contentData.imageList && item.templateData.contentData.imageList.length > 0"
                    :src="item.templateData.contentData.imageList[0]" />
                </div>
              </div>
              <div class="content-box" :class="list.length == 1 ? 'content-box-radius' : ''"
                v-if="item.templateData.contentType == 104 && item.templateData.contentData?.title1?.text">
                <div class="content-border">
                  <div class="card-box">
                    <div class="box-left">
                      <div class="tag" v-if="item.templateData.titleData?.title1?.text">
                        {{ item.templateData.titleData?.title1?.text }}</div>
                      <p class="content-card">{{ item.templateData.contentData?.title1?.text }}</p>
                      <p class="publish">
                        <span class="name">{{ item.templateData.contentData?.title2?.text }}</span>
                        <span class="time">{{ item.templateData.contentData?.title3?.text }}</span>
                      </p>
                    </div>
                    <img class="jump" src="~@/assets/jiantou@3x.png">
                  </div>
                </div>
              </div>
              <div class="content-box" :class="list.length == 1 ? 'content-box-radius' : ''"
                v-if="item.templateType == 573 && item.templateData.contentData?.contentTitle?.text">
                <div class="content-border">
                  <div class="video-box">
                    <div class="box-left">
                      <div class="text">
                        <img class="top" v-if="item.templateData.contentData.topUrl"
                          :src="item.templateData.contentData.topUrl" />
                        <span :class="item.templateData.contentData.topUrl ? 'top-padding' : ''">{{
                          item.templateData.contentData?.contentTitle?.text }}</span>
                      </div>
                      <p class="publish">
                        <span class="name">{{ item.templateData.titleData?.title1?.text }}</span>
                        <span class="time">{{ item.templateData.titleData?.title2?.text }}</span>
                      </p>
                    </div>

                  </div>
                  <img class="video-img" :src="item.templateData.contentData?.videoInfo?.pictureUrl">
                </div>
              </div>
            </a>
          </div>
        </template>
        <TimeLine v-if="props.detailType == 3 && list.length > 0" ref="timeline" :list="list" />
        <NoData :msg="msg" v-if="list.length == 0 && finished" />
      </List>
    </div>
    <img v-if="finished" class="logo" src="~@/assets/logo@3x.png">
  </div>
</template>

<script setup>
import { onMounted, ref, reactive, nextTick, onBeforeMount, onBeforeUnmount } from 'vue';
import { List } from 'vant';
import { subjectTabData } from '@/api/';
import * as tools from '@/utils/utils';
import JUMP from '@/utils/jump'
import TimeLine from './TimeLine'
import NoData from './NoData'
const props = defineProps({
  subjectVoList: Array,
  tabData: Object,
  detailType: Number,
  headerData: Object,
  active: Number,
});
import { feedDATA } from '../data/feed'
const finished = ref(false)
const loading = ref(false)
const timeline = ref(null)
const list = ref([])
const isFirst = ref(true)
const msg = '小编正在编辑中~'
const params = reactive({
  tagId: props.tabData.tagId,
  lastId: '',
  pageSize: props.subjectVoList[props.active].detailType == 3 ? 100 : 20,
  subjectId: props.tabData.subjectId // 专题合集头部，子专题id
})
const onLoad = () => {
  loading.value = true;
  getSubjectData()
}
// 获取子tab数据
const getSubjectData = async (value) => {
  if (params.subjectId == 2710472 && isFirst.value) {
    const data = feedDATA
    loading.value = false
    if (props.tabData.tagId == 109 && list.value.length > 0) {
      let arr = data.resultList
      if (list.value[list.value.length - 1].timeLineName == arr[0].timeLineName) {
        for (let i = 0; i < arr[0].dataList.length; i++) {
          list.value[list.value.length - 1].dataList.push(arr[0].dataList[i])
        }
        arr.shift()
      }
      list.value.push(...arr)
    } else {
      list.value.push(...data.resultList)
    }
    finished.value = data.isEnd
    params.lastId = data.lastId
    // setTimeout(() => {
    //   if (props.tabData.tagId == 109 && !data.isEnd) {
    //     timeline.value.init()
    //   }
    // }, 500);
    isFirst.value = false
  } else {
    try {
      const { resultData: { data } } = await subjectTabData({
        ...params
      })
      loading.value = false
      if (props.tabData.tagId == 109 && list.value.length > 0) {
        let arr = data.resultList
        if (list.value[list.value.length - 1].timeLineName == arr[0].timeLineName) {
          for (let i = 0; i < arr[0].dataList.length; i++) {
            list.value[list.value.length - 1].dataList.push(arr[0].dataList[i])
          }
          arr.shift()
        }
        list.value.push(...arr)
      } else {
        list.value.push(...data.resultList)
      }
      finished.value = data.isEnd
      params.lastId = data.lastId
      // setTimeout(() => {
      //   if (props.tabData.tagId == 109 && !data.isEnd) {
      //     timeline.value.init()
      //   }
      // }, 500);
    } catch (error) {
      console.log(error)
    }
  }

}
const handleJumpDetail = (item) => {
  JUMP(item)
}

const handleURL = (item) => {
  // console.log('item ---> ', item)
  const id = item.templateData.jumpData.productId
  const jumpUrl = item.templateData.jumpData.jumpUrl
  if (item.templateType == 588) {
    return `https://content.jr.jd.com/article/index.html?pageId=${id}`
  } else if (item.templateType == 573) {
    return `https://content.jr.jd.com/shareProject/shortVideo/transverse/index.html?contentId=${id}`
  } else {
    return jumpUrl
  }
}

onMounted(() => {
  loading.value = false
  finished.value = false
  list.value = []
  params.lastId = ''
  onLoad()
  console.log(props.headerData.subjectVoList)
});
</script>

<style lang="scss" scoped>
.feed {
  width: 100%;
  position: relative;

  .list {
    width: 100%;
    margin-bottom: 24px;

    .content-box {
      width: 100%;
      background: rgba(255, 255, 255, 1);
      // height: 200px;
      padding: 0 32px;

      .content-border {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        border-bottom: 1px solid rgba(238, 238, 238, 1);
        padding: 28px 0;
      }

      .content {
        width: 392px;
        min-height: 144px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;

        .text-article {
          margin-bottom: 10px;
        }

        .text,
        .text h2 {
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          display: -webkit-box;
          /* 将对象作为弹性伸缩盒子模型显示 */
          -webkit-box-orient: vertical;
          /* 设置或检索伸缩盒对象的子元素的排列方式 */
          -webkit-line-clamp: 2;
          /* 2行，只有 webkit内核支持 */
          word-break: break-all;
          /* 纯英文换行 */
          overflow: hidden;

          .top {
            display: inline-block;
            width: 68px;
            height: auto;
            position: absolute;
            top: 3px;
            left: 1px;
          }

          .top-padding {
            padding-left: 75px;
          }
        }

        .publish {
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: normal;
          color: rgba(153, 153, 153, 1);

          .name {
            display: inline-block;
            margin-right: 10px;
          }
        }
      }

      .image {
        width: 220px;
        height: 144px;
        border-radius: 8px;
      }

      .card-box {
        width: 100%;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .box-left {
          width: 521px;

          .tag {
            display: inline-block;
            width: auto;
            padding: 0 12px;
            height: 32px;
            line-height: 32px;
            background: linear-gradient(226.66deg, rgba(255, 121, 116, 1) 0%, rgba(255, 47, 38, 1) 100%);
            border-radius: 4px;
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 20px;
          }

          .content-card {
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            display: -webkit-box;
            /* 将对象作为弹性伸缩盒子模型显示 */
            -webkit-box-orient: vertical;
            /* 设置或检索伸缩盒对象的子元素的排列方式 */
            -webkit-line-clamp: 2;
            /* 2行，只有 webkit内核支持 */
            word-break: break-all;
            /* 纯英文换行 */
            overflow: hidden;
            margin-bottom: 3px;
          }

          .publish {
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: normal;
            color: rgba(153, 153, 153, 1);

            .name {
              display: inline-block;
              margin-right: 10px;
            }
          }
        }

        .jump {
          width: 26px;
          height: 26px;
        }
      }

      .video-box {
        width: 100%;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        // display: flex;
        // align-items: center;
        // justify-content: space-between;
        position: relative;

        .box-left {
          max-width: 392px;
          height: 144px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .text {
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            display: -webkit-box;
            /* 将对象作为弹性伸缩盒子模型显示 */
            -webkit-box-orient: vertical;
            /* 设置或检索伸缩盒对象的子元素的排列方式 */
            -webkit-line-clamp: 2;
            /* 2行，只有 webkit内核支持 */
            word-break: break-all;
            /* 纯英文换行 */
            overflow: hidden;

            .top {
              display: inline-block;
              width: 68px;
              height: auto;
              position: absolute;
              top: 3px;
              left: 1px;
            }

            .top-padding {
              padding-left: 75px;
            }
          }

          .publish {
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: normal;
            color: rgba(153, 153, 153, 1);

            .name {
              display: inline-block;
              margin-right: 10px;
            }
          }
        }

      }

      .video-img {
        width: 220px;
        height: 144px;
        background: rgba(0, 0, 0, 0.11);
        border-radius: 8px;
      }
    }

    // .content-box:first-child {
    //   border-radius: 8px 8px 0 0;
    // }
    // .content-box:last-child {
    //   border-radius: 0 0 8px 8px;
    // }
    .content-box-radius {
      border-radius: 8px !important;
    }
  }

  .logo {
    width: 100%;
    height: 168px;
  }
}
</style>

